/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import { OrderPaymentDetail } from '../order/types';
import {
  checkoutState,
  checkoutAction,
  checkoutActionTypes,
  ServicesCheckoutProps,
  errorData,
  CheckoutItemsProps,
} from './types';

const INITIAL_STATE: checkoutState = {
  checkout: {
    id: 0,
    grand_total: '0.00',
    sub_total: '0.00',
    items: {},
    items_count: 0,
    discount: '0.00',
    shipping: 0
  },
  shipping: 0,
  error: false,
  loading: false,
  methodPaymentSelected: {
    cards: [],
    cashOnDelivery: [],
    others: [],
  },
  orderCheckout: {
    order: {},
    payment_detail: {} as OrderPaymentDetail
  }
};

export default function Checkout(
  state = INITIAL_STATE,
  action: checkoutAction,
): checkoutState {
  let newServices: ServicesCheckoutProps[];

  switch (action.type) {
    case checkoutActionTypes.CHECKOUT_SUCESS:
      const items: Record<string, CheckoutItemsProps> = {};
      action.payload.checkout.items.forEach(item => {
        items[item.product.product_id as string] = item
      });

      return {
        ...state,
        checkout: {
          ...action.payload.checkout,
          items,
        },
        loading: false,
      };
    case checkoutActionTypes.CHECKOUT_FAILURE:
      return {
        ...state,
        checkout: {
          id: 0,
          grand_total: '0.00',
          sub_total: '0.00',
          items: {},
          items_count: 0,
          discount: '0.00',
          shipping: 0,
        },
        loading: false,
      };
    case checkoutActionTypes.SET_SHIPPING_PRICE: {
      return {
        ...state,
        shipping: action.payload.shipping,
        checkout: {
          ...state.checkout,
        },
      };
    }
    case checkoutActionTypes.CLOSE_SALE:
      return {
        ...state,
        errorData: undefined,
        loading: true,
        error: false,
      };
    case checkoutActionTypes.CLOSE_SALE_SUCCESS:
      return {
        ...state,
        checkout: {
          id: 0,
          grand_total: '0.00',
          sub_total: '0.00',
          items: {},
          items_count: 0,
          discount: '0.00',
          shipping: 0,
        },
        order: action.payload.order,
        errorData: undefined,
        loading: false,
        error: false,
      };
    case checkoutActionTypes.CLOSE_SALE_FAILURE:
      return {
        ...state,
        errorData: action.payload.error,
        loading: false,
        error: true,
      };
    case checkoutActionTypes.CLEAR_SALE:
      return {
        ...state,
        checkout: {
          id: 0,
          grand_total: '0.00',
          sub_total: '0.00',
          items: {},
          items_count: 0,
          discount: '0.00',
          shipping: 0,
        },
        errorData: undefined,
        loading: false,
        error: false,
      };
    case checkoutActionTypes.VOIDED_SALE_SUCCESS:
      return {
        ...state,
        checkout: {
          id: 0,
          grand_total: '0.00',
          sub_total: '0.00',
          items: {},
          items_count: 0,
          discount: '0.00',
          shipping: 0,
        },
        errorData: undefined,
        loading: false,
        error: false,
      };
    case checkoutActionTypes.ORDER_ID_REMAKE_REQUEST:
      return {
        ...state,
        checkout: {
          ...state.checkout,
        },
        loading: true,
        error: false,
      };

    case checkoutActionTypes.ORDER_ID_REMAKE_SUCCESS:
      // konsole.log('checkoutActionTypes.ORDER_ID_REMAKE_SUCCESS: ', checkoutItems);
      // konsole.log('checkoutActionTypes.ORDER_ID_REMAKE_SUCCESS->countProduct: ', checkoutWrk.countProduct);
      // konsole.log('checkoutActionTypes.ORDER_ID_REMAKE_SUCCESS->total: ', checkoutWrk.total);

      return {
        ...state,
        checkout: {
          ...state.checkout,
        },
        loading: false,
        error: false,
      };

    case checkoutActionTypes.CLEAR_ERROR:
      return {
        ...state,
        error: false,
        errorData: {} as errorData,
      };
    case checkoutActionTypes.SEND_REQUEST_NEW:
      return {
        ...state,
        loading: true,
        error: false,
        errorData: undefined,
      };
    case checkoutActionTypes.SEND_REQUEST_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        order: action.payload.order,
        error: false,
        errorData: undefined,
      };
    case checkoutActionTypes.SET_SERVICES:
      if (state.checkout.services && state.checkout.services?.length > 0) {
        newServices = [...state.checkout.services];
        newServices.push(action.payload.services);
      } else {
        newServices = [action.payload.services];
      }
      return {
        ...state,
        checkout: {
          ...state.checkout,
          services: newServices,
        },
      };
    case checkoutActionTypes.DELET_SERVICES:
      if (state.checkout.services && state.checkout.services?.length > 0) {
        const oldService = [...state.checkout.services];
        newServices = oldService.filter(
          service => service.product_id !== action.payload.id,
        );
        return {
          ...state,
          checkout: {
            ...state.checkout,
            services: newServices,
          },
        };
      }
      return {
        ...state,
      };
    case checkoutActionTypes.CHANGE_SERVICES:
      if (state.checkout.services && state.checkout.services?.length > 0) {
        const oldService = [...state.checkout.services];
        newServices = oldService.map(data => {
          if (data.product_id === action.payload.id) {
            return {
              ...data,
              service: action.payload.service,
            };
          }
          return data;
        });
        return {
          ...state,
          checkout: {
            ...state.checkout,
            services: newServices,
          },
        };
      }
      return {
        ...state,
      };
    case checkoutActionTypes.METHOD_PAYMENT_SELECTED:
      return {
        ...state,
        methodPaymentSelected: action.payload,
      }
    case checkoutActionTypes.VERIFY_CUSTOMER_CARD_IS_EXIST_SUCESS:
      return {
        ...state,
        loading: false,
        checkout: {
          ...state.checkout,
          customer: {
            message: action.payload.customer.message,
            data: {
              ...action.payload.customer.data,
              customer: {
                ...action.payload.customer.data.customer,
                address: action.payload.customer.data.customer.address || [],
              },
            },
          },
        },
      };
    case checkoutActionTypes.LOGOUT_CUSTOMER_CARD:
      return {
        ...state,
        checkout: {
          ...state.checkout,
          customer: undefined,
        },
      };
    case checkoutActionTypes.CREATE_OR_UPDATE_CUSTOMER_CARD_SUCESS:
       return {
          ...state,
          loading: false,
        };
    case checkoutActionTypes.REMOVE_ADDRESS_CUSTOMER_CARD_SUCESS:
      if (state.checkout.customer) {
        return {
          ...state,
          loading: false,
        };
      } else {
        return {
          ...state,
          loading: false,
        };
      }
    case checkoutActionTypes.CLEAR_MESSAGE_CUSTOMER_CARD:
      if (state.checkout.customer) {
        return {
          ...state,
          checkout: {
            ...state.checkout,
            customer: {
              ...state.checkout.customer,
              message: '',
            },
          },
        };
      }
      return state;
    case checkoutActionTypes.GET_CHECKOUT:
    case checkoutActionTypes.UPLOAD_CHECKOUT:
    case checkoutActionTypes.ADD_PLU_CHECKOUT:
    case checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT:
    case checkoutActionTypes.REMOVE_PLU_CHECKOUT:
    case checkoutActionTypes.REMOVE_ADDRESS_CUSTOMER_CARD:
    case checkoutActionTypes.UPDATE_CUSTOMER_CARD:
    case checkoutActionTypes.SELECT_ADDRESS_CUSTOMER_CARD:
    case checkoutActionTypes.CREATE_OR_UPDATE_CUSTOMER_CARD:
    case checkoutActionTypes.VERIFY_CUSTOMER_CARD_IS_EXIST:
    case checkoutActionTypes.APPLY_COUPON:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case checkoutActionTypes.CHECK_PAYMENT_REQUEST:
      return {
        ...state,
        error: false,
      }
    case checkoutActionTypes.CHECK_PAYMENT_RESPONSE:
      return {
        ...state,
        loading: false,
      };
    case checkoutActionTypes.CLEAR_LOADING:
      return {
        ...state,
        loading: false,
      };
    case checkoutActionTypes.ORDER_CHECKOUT_RESPONSE:
      return {
        ...state,
        orderCheckout: {
          order: action.payload.orderCheckout.order,
          payment_detail: action.payload.orderCheckout.order.payment_detail?.[0] || {} as OrderPaymentDetail
        }
      }
    case checkoutActionTypes.ORDER_CHECKOUT_CLEAR:
      return {
        ...state,
        orderCheckout: {
          order: {},
          payment_detail: {} as OrderPaymentDetail
        }
      }
    default:
      return state;
  }
}
